import { IPermissionConfig } from "../config/interfaces";
import { Permissions } from "./../config/Permissions";

export default class RulesService {
	userPermissions: Array<string>;

	constructor(_userPermissions: Array<string>) {
		this.userPermissions = _userPermissions || [];
	}

	// TODO: Remove dummyPermission later
	public get dummyPermission(): IPermissionConfig {
		return { permissions: [Permissions.TEST] };
	}

	public get getMyProfile(): IPermissionConfig {
		return { permissions: [Permissions.GET_MY_PROFILE] };
	}

	public get updateMyProfile(): IPermissionConfig {
		return { permissions: [Permissions.UPDATE_MY_PROFILE] };
	}

	public get deleteMyProfile(): IPermissionConfig {
		return { permissions: [Permissions.DELETE_MY_PROFILE] };
	}

	public get changePasswordMyProfile(): IPermissionConfig {
		return { permissions: [Permissions.CHANGE_PASSWORD_MY_PROFILE] };
	}

	public get createUser(): IPermissionConfig {
		return { permissions: [Permissions.CREATE_USER] };
	}

	public get updateUser(): IPermissionConfig {
		return { permissions: [Permissions.UPDATE_USER] };
	}

	public get singleUser(): IPermissionConfig {
		return { permissions: [Permissions.SINGLE_USER] };
	}

	public get usersList(): IPermissionConfig {
		return { permissions: [Permissions.LIST_USER] };
	}

	public get deleteUser(): IPermissionConfig {
		return { permissions: [Permissions.DELETE_USER] };
	}

	public get activateUser(): IPermissionConfig {
		return { permissions: [Permissions.ACTIVATE_USER] };
	}

	public get deactivateUser(): IPermissionConfig {
		return { permissions: [Permissions.DEACTIVATE_USER] };
	}

	public get userStatusUpdate(): IPermissionConfig {
		return {
			permissionsAnd: [Permissions.ACTIVATE_USER, Permissions.DEACTIVATE_USER]
		};
	}

	public get userChangePassword(): IPermissionConfig {
		return { permissions: [Permissions.CHANGE_PASSWORD_USER] };
	}

	public get createGlobalSetting(): IPermissionConfig {
		return { permissions: [Permissions.CREATE_GLOBAL_SETTING] };
	}

	public get updateGlobalSetting(): IPermissionConfig {
		return { permissions: [Permissions.UPDATE_GLOBAL_SETTING] };
	}

	public get singleGlobalSettingByKey(): IPermissionConfig {
		return { permissions: [Permissions.SINGLE_GLOBAL_SETTING_BY_KEY] };
	}

	public get singleGlobalSetting(): IPermissionConfig {
		return { permissions: [Permissions.SINGLE_GLOBAL_SETTING] };
	}

	public get globalSettingList(): IPermissionConfig {
		return { permissions: [Permissions.LIST_GLOBAL_SETTING] };
	}

	public get deleteGlobalSetting(): IPermissionConfig {
		return { permissions: [Permissions.DELETE_GLOBAL_SETTING] };
	}

	public get userPlanList(): IPermissionConfig {
		return {
			permissions: [Permissions.LIST_PLAN, Permissions.LIST_GLOBAL_SETTING]
		};
	}

	public get plansList(): IPermissionConfig {
		return { permissions: [Permissions.LIST_PLAN] };
	}

	public get createPlan(): IPermissionConfig {
		return { permissions: [Permissions.CREATE_PLAN] };
	}

	public get updatePlan(): IPermissionConfig {
		return { permissions: [Permissions.UPDATE_PLAN] };
	}

	public get singlePlan(): IPermissionConfig {
		return { permissions: [Permissions.SINGLE_PLAN] };
	}

	public get singlePlanBySlug(): IPermissionConfig {
		return { permissions: [Permissions.SINGLE_PLAN_BY_SLUG] };
	}

	public get incomeSourcePlanList(): IPermissionConfig {
		return { permissions: [Permissions.LIST_INCOME_SOURCE_PLAN] };
	}

	public get deletePlan(): IPermissionConfig {
		return { permissions: [Permissions.DELETE_PLAN] };
	}

	public get createEFilingPlan(): IPermissionConfig {
		return { permissions: [Permissions.CREATE_EFILING_PLAN] };
	}

	public get updateEFilingPlan(): IPermissionConfig {
		return { permissions: [Permissions.UPDATE_EFILING_PLAN] };
	}

	public get singleEFilingPlan(): IPermissionConfig {
		return { permissions: [Permissions.SINGLE_EFILING_PLAN] };
	}

	public get eFilingPlanList(): IPermissionConfig {
		return { permissions: [Permissions.LIST_EFILING_PLAN] };
	}

	public get deleteEFilingPlan(): IPermissionConfig {
		return { permissions: [Permissions.DELETE_EFILING_PLAN] };
	}

	public get createEFilingPlanTransaction(): IPermissionConfig {
		return { permissions: [Permissions.CREATE_EFILING_PLAN_TRANSACTION] };
	}

	public get updateEFilingPlanTransaction(): IPermissionConfig {
		return { permissions: [Permissions.UPDATE_EFILING_PLAN_TRANSACTION] };
	}

	public get singleEFilingPlanTransaction(): IPermissionConfig {
		return { permissions: [Permissions.SINGLE_EFILING_PLAN_TRANSACTION] };
	}

	public get eFilingPlanTransactionList(): IPermissionConfig {
		return { permissions: [Permissions.LIST_EFILING_PLAN_TRANSACTION] };
	}

	public get deleteEFilingPlanTransaction(): IPermissionConfig {
		return { permissions: [Permissions.DELETE_EFILING_PLAN_TRANSACTION] };
	}

	public get createEFiling(): IPermissionConfig {
		return { permissions: [Permissions.CREATE_EFILING] };
	}

	public get updateEFiling(): IPermissionConfig {
		return { permissions: [Permissions.UPDATE_EFILING] };
	}

	public get updateAndSingleEFiling(): IPermissionConfig {
		return { permissions: [Permissions.UPDATE_EFILING, Permissions.SINGLE_EFILING] };
	}

	public get createAndUpdateEFiling(): IPermissionConfig {
		return { permissionsAnd: [Permissions.CREATE_EFILING, Permissions.UPDATE_EFILING] };
	}

	public get singleEFiling(): IPermissionConfig {
		return { permissions: [Permissions.SINGLE_EFILING] };
	}

	public get eFilingList(): IPermissionConfig {
		return { permissions: [Permissions.LIST_EFILING] };
	}

	public get deleteEFiling(): IPermissionConfig {
		return { permissions: [Permissions.DELETE_EFILING] };
	}

	public get createEFilingMessageChannel(): IPermissionConfig {
		return { permissions: [Permissions.CREATE_EFILING_MESSAGE_CHANNEL] };
	}

	public get updateEFilingMessageChannel(): IPermissionConfig {
		return { permissions: [Permissions.UPDATE_EFILING_MESSAGE_CHANNEL] };
	}

	public get eFilingMessageChannelList(): IPermissionConfig {
		return { permissions: [Permissions.LIST_EFILING_MESSAGE_CHANNEL] };
	}

	public get deleteEFilingMessageChannel(): IPermissionConfig {
		return { permissions: [Permissions.DELETE_EFILING_MESSAGE_CHANNEL] };
	}

	public get createEFilingMessage(): IPermissionConfig {
		return { permissions: [Permissions.CREATE_EFILING_MESSAGE] };
	}

	public get updateEFilingMessage(): IPermissionConfig {
		return { permissions: [Permissions.UPDATE_EFILING_MESSAGE] };
	}

	public get singleEFilingMessage(): IPermissionConfig {
		return { permissions: [Permissions.SINGLE_EFILING_MESSAGE] };
	}

	public get eFilingMessageList(): IPermissionConfig {
		return { permissions: [Permissions.LIST_EFILING_MESSAGE] };
	}

	public get deleteEFilingMessage(): IPermissionConfig {
		return { permissions: [Permissions.DELETE_EFILING_MESSAGE] };
	}

	public get createEFilingAuthorizedUser(): IPermissionConfig {
		return { permissions: [Permissions.CREATE_EFILING_AUTHORIZED_USER] };
	}

	public get deleteEFilingAuthorizedUser(): IPermissionConfig {
		return { permissions: [Permissions.DELETE_EFILING_AUTHORIZED_USER] };
	}

	public get createEFilingDocument(): IPermissionConfig {
		return { permissions: [Permissions.CREATE_EFILING_DOCUMENT] };
	}

	public get deleteEFilingDocument(): IPermissionConfig {
		return { permissions: [Permissions.DELETE_EFILING_DOCUMENT] };
	}

	// Used for Admin to show track status dropdown
	public get AdminEFilingStatus(): IPermissionConfig {
		return {
			permissionsAnd: [
				Permissions.EFILING_STATUS_CALLED,
				Permissions.EFILING_STATUS_CONVERTED,
				Permissions.EFILING_STATUS_NOT_CONVERTED,
				Permissions.EFILING_STATUS_REQUESTED_DETAILS,
				Permissions.EFILING_STATUS_REQUESTED_DETAILS_RECEIVED,
				Permissions.EFILING_STATUS_DETAILS_SENT,
				Permissions.EFILING_STATUS_RECEIVED_DETAILS,
				Permissions.EFILING_STATUS_FILE_UNDER_PROCESSING,
				Permissions.EFILING_STATUS_FILE_PROCESSED
			]
		};
	}

	// Used for CA to show track status dropdown
	public get TaxExpertEFilingStatus(): IPermissionConfig {
		return {
			permissionsAnd: [
				Permissions.EFILING_STATUS_REQUESTED_DETAILS,
				Permissions.EFILING_STATUS_RECEIVED_DETAILS,
				Permissions.EFILING_STATUS_FILE_UNDER_PROCESSING,
				Permissions.EFILING_STATUS_FILE_PROCESSED
			]
		};
	}

	// Used for User/Expert to show track status badge
	public get UserAndExpertStatusBadge(): IPermissionConfig {
		return {
			permissions: [
				Permissions.EFILING_STATUS_REQUESTED_DETAILS,
				Permissions.EFILING_STATUS_RECEIVED_DETAILS,
				Permissions.EFILING_STATUS_REQUESTED_DETAILS_RECEIVED,
				Permissions.EFILING_STATUS_DETAILS_SENT,
				Permissions.EFILING_STATUS_FILE_UNDER_PROCESSING,
				Permissions.EFILING_STATUS_FILE_PROCESSED
			]
		};
	}

	canAccess(permissionData: IPermissionConfig | null): boolean {
		const defaultPermissionData: IPermissionConfig = {
			groups: [],
			groupsAnd: [],
			permissions: [],
			permissionsAnd: []
		};

		const data = Object.assign({}, defaultPermissionData, permissionData);
		let res = true;
		// or permissions
		if (res && data.permissions && data.permissions.length) {
			let permres = false;
			for (const prm of data.permissions) {
				if (this.userPermissions.includes(prm)) {
					// the first hasPermission is enough
					permres = true;
					break;
				}
			}
			res = permres;
		}

		// and permissions
		if (res && data.permissionsAnd && data.permissionsAnd.length) {
			let permandres = true;
			for (const prm of data.permissionsAnd) {
				if (!this.userPermissions.includes(prm)) {
					// the first permission not allowed is enough to reject
					permandres = false;
					break;
				}
			}
			res = permandres;
		}

		// if authorized so return true
		return res;
	}
}
